import { Link } from 'react-router-dom';
import { images } from '../../assets/images';

const team = [
  {
    id: 1,
    name: 'Robert Fox',
    role: 'Chief Engineer',
    image: images.team.engineer
  },
  {
    id: 2,
    name: 'Jane Cooper',
    role: 'Production Manager',
    image: images.team.manager
  },
  {
    id: 3,
    name: 'Jivan Singh',
    role: 'Sales Manager',
    image: 'https://s3.us-west-2.amazonaws.com/yourware-assets/user_assets/dz3tE9Qf72YjcgQlgzv1mVaSmyO2/d58b37fc-dce4-4789-95da-47fb0de0ca21/1j51zbmu32.png?AWSAccessKeyId=AKIATX3PIHBRXURDBIHW&Signature=dMrKUMd%2BBJlR8bT5IUenhXscDVg%3D&Expires=1770556867'
  }
];

const TeamPreview = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-orange-600 font-bold uppercase tracking-wider text-sm">Our Team</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2">Meet The Experts</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {team.map((member) => (
            <div key={member.id} className="group text-center">
              <div className="relative mb-6 inline-block overflow-hidden rounded-full border-4 border-slate-100 w-48 h-48">
                <img 
                  src={member.image} 
                  alt={member.name} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <h3 className="text-xl font-bold text-slate-900">{member.name}</h3>
              <p className="text-orange-600 font-medium">{member.role}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link 
            to="/team" 
            className="text-slate-600 font-medium hover:text-orange-600 transition-colors border-b border-slate-300 hover:border-orange-600 pb-1"
          >
            View All Team Members
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TeamPreview;
